app.controller("StSubController", ["$scope", "$q", "$state", "StSubject", "Selection", "Users", "Students", "$uibModal", "ConfirmModal", "$stateParams", "toastr", "usSpinnerService",
    function ($scope, $q, $state, StSubject, Selection, Users, Students, $uibModal, ConfirmModal, $stateParams, toastr, usSpinnerService) {
        $scope.subjects = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.allSubjects = [];
        $scope.wrapperis = [];
        $scope.selections = [];
        $scope.student = {};
        $scope.allCredits = 0;
        $scope.lastSemesterCredits = 0;
        $scope.lecturerProfile = $state.current.name === 'lecturer.studentCard';
        Users.profile($stateParams.studentId).then(function (data) {
            $scope.lastSemester = data.info.semester - 1;
            return $scope.student = data
        });
        $scope.generatedDates = {};

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.toggle = function () {
            $scope.enabled = !$scope.enabled
        };

        function renderSelections(selections) {
            $scope.allCredits = 0;
            $scope.allSubjects = selections;
            var stSubjects = $scope.allSubjects;

            let key = $scope.lecturerProfile ? 'listForHead' : 'list';
            Selection[key]({
                query: $stateParams.query,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                var activeSubjects = data;

                for (var i = 0; i < stSubjects.length; i++) {
                    for (var j = 0; j < activeSubjects.length; j++) {
                        if (stSubjects[i].state && stSubjects[i].state === "passed") {
                        } else if ((stSubjects[i].name === activeSubjects[j].subject.name) && !$scope.allSubjects[i].selection) {
                            $scope.allSubjects[i].active = true;
                        }
                    }
                }
            });

            $scope.confessed = _(selections).filter(function (v) {
                return v.confessed && v.selectionState !== 'archived';
            }).value();
            $scope.archived = _(selections).filter({selectionState: 'archived'}).value();
            $scope.confessedCredits = _.sumBy($scope.confessed, 'credits');
            $scope.allCredits += $scope.confessedCredits;

            $scope.semesterSubjects = _(selections).filter(function (s) {
                return !s.confessed && s.selectionState !== 'archived';
            }).mapValues(function (s) {
                s.semester = s.semester || null;
                return s;
            }).groupBy('semester').mapValues(function (s) {
                return {
                    subjects: s, sum: _(s).filter(function (x) {
                        if (x.credits && x.state === 'passed') $scope.allCredits += x.credits;
                        return x.state === 'passed'
                    }).sumBy('credits'), average: _(s).filter(function (x) {
                        return x.state !== 'current';
                    }).meanBy('score')
                }
            }).value();

            $scope.keys = _.keys($scope.semesterSubjects).reverse();
            $scope.generateDate();
            $scope.lastSemesterSubjects = $scope.semesterSubjects[$scope.lastSemester] ? $scope.semesterSubjects[$scope.lastSemester].subjects : null;
            $scope.lastSemesterCredits = $scope.lastSemesterSubjects ? _.sumBy($scope.lastSemesterSubjects, 'credits') : 0;
        }

        $scope.generateCredits = function (semester) {
            return _.sumBy($scope.semesterSubjects[semester].subjects, 'credits');
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            $q.all([StSubject.list({
                page: page,
                limit: $scope.itemsPerPage,
                student: $stateParams.studentId
            }), StSubject.totals({student: $stateParams.studentId})]).then(function (data) {
                var selections = data[0];
                var totals = data[1];
                $scope.average = totals.average;
                $scope.gpa = totals.gpa;
                renderSelections(selections);
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.details = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DetailsController",
                templateUrl: _pb + 'student/card/details.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    subject: function () {
                        return subject
                    }
                }
            }).result
                .then(function (result) {

                });
        };

        $scope.subjectDetails = function (selection, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go('admin.subject-details', {subjectId: selection.subject._id})
        };

        $scope.byProgram = function (student) {
            $state.go("admin.studentCardByProgram", {
                studentId: student._id,
                student: student,
                allCredits: $scope.allCredits,
                lastSemesterCredits: $scope.lastSemesterCredits
            });
        };

        $scope.recognition = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "SubjectConfessionController",
                templateUrl: _pb + 'admin/students/subject-confession.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function () {
                    loadPage($scope.currentPage);
                }, function () {
                    loadPage($scope.currentPage);
                });
        };

        $scope.printStudentCard = function (student) {
            window.open('subject/export/' + student._id);
        };

        $scope.generateDate = function () {
            let season = null;
            let year = '';

            for (var k in $scope.keys) {
                var subjectSelections = $scope.semesterSubjects[$scope.keys[k]].subjects;
                subjectSelections = subjectSelections.find(function (f) {
                    return f.selectionTime
                });

                if (subjectSelections) {
                    year = subjectSelections.subjectActivation.season.slice(0, 4);
                    const month = subjectSelections.subjectActivation.season.slice(5);
                    if(month === 'autumn') {
                        season = 'შემოდგომა'
                    } else {
                        season = 'გაზაფხული'
                    }
                }
                $scope.generatedDates[$scope.keys[k]] = subjectSelections ? year + ' ' + season : '';
            }

        };

        $scope.edit = function (student, subject, $event) {
            if (subject.subjectWrapper) subject.subjectWrapper.subject = subject.subject;
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "EditScoreController",
                templateUrl: _pb + 'admin/students/edit-score.html',
                size: "md",
                resolve: {
                    subject: subject,
                    student: student
                }
            }).result
                .then(function () {
                    loadPage($scope.currentPage);
                }, function () {
                    loadPage($scope.currentPage);
                });
        };

        $scope.remove = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "შეფასების წაშლა",
                message: "გსურთ   " + subject.name + "-ის შეფასების წაშლა?"
            }).result.then(function () {
                Selection.removeSelection(subject._id)
                    .then(function () {
                        toastr.success('', 'შეფასება წაშლილია');
                        loadPage($scope.currentPage);
                    });
            });
        };


        $scope.selectGroup = function (student, subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "SelectGroupController",
                templateUrl: _pb + 'admin/students/select-group.html',
                size: "md",
                resolve: {
                    student: student,
                    subject: subject
                }
            }).result
                .then(function () {
                    loadPage($scope.currentPage);
                }, function () {
                    loadPage($scope.currentPage);
                });
        };

        $scope.unarchiveSelections = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "საგნების ამოარქივება",
                message: "გსურთ სტუდენტისთვის საგნების ამოარქივება?"
            }).result.then(function () {
                Students.unarchiveSelections(student._id).then(function () {
                    toastr.success('', 'საგნები ამოარქივდა.');
                    loadPage($scope.currentPage);
                })
            });
        };

        $scope.archiveSelections = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "საგნების დაარქივება",
                message: "გსურთ სტუდენტისთვის საგნების დაარქივება?"
            }).result.then(function () {
                Students.archiveSelections(student._id).then(function () {
                    toastr.success('', 'საგნები დაარქივდა.');
                    loadPage($scope.currentPage);
                })
            });
        };

        $scope.archiveOneSelection = function (selection, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "საგნის დაარქივება",
                message: "გსურთ სტუდენტისთვის არჩეული საგნის დაარქივება?"
            }).result.then(function () {
                Selection.archiveOneSelection({selectionId: selection._id}).then(function () {
                    toastr.success('', 'საგანი დაარქივდა.');
                    loadPage($scope.currentPage);
                })
            });
        };

        $scope.unArchiveOneSelection = function (selection, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "საგნის ამოარქივება",
                message: "გსურთ სტუდენტისთვის არჩეული საგნის ამოარქივება?"
            }).result.then(function () {
                Selection.unArchiveOneSelection({selectionId: selection._id}).then(function () {
                    toastr.success('', 'საგანი ამოარქივდა.');
                    loadPage($scope.currentPage);
                })
            });
        };
    }
]);
